
import { siteUrlsSelector } from '../../bootstrap/redux/selectors/SiteUrlsSelectors';
import { getAppStore } from '../../bootstrap/redux/store/AppStore';
import {
  IContentType,
} from '../../spacesPlatform/models/ContentTypes';

export function ContentUrlForItem(item: { id: string, path?: string }, itemType: IContentType) {

  if (itemType.name === 'workbook') {
    const siteUrls = siteUrlsSelector(getAppStore().getState());
    return siteUrls ? siteUrls.workbookUrl(item.id) : '';

  } else if (itemType.name === 'datasource') {
    const siteUrls = siteUrlsSelector(getAppStore().getState());
    return siteUrls ? siteUrls.datasourceUrl(item.id) : '';

  } else if (itemType.name === 'view') {
    // only shows up in ChangeViewTagsAction and the item type is IViewBase there
    const siteUrls = siteUrlsSelector(getAppStore().getState());
    return siteUrls ? siteUrls.viewUrl(item.path) : '';

  } else if (itemType.name === 'project') {
    const siteUrls = siteUrlsSelector(getAppStore().getState());
    return siteUrls ? siteUrls.projectUrl(item.id) : '';

  } else if (itemType.name === 'virtualConnection') {
    const siteUrls = siteUrlsSelector(getAppStore().getState());
    return siteUrls ? siteUrls.projectUrl(item.id) : '';

  } else if (itemType.name === 'virtualConnectionTable') {
    const siteUrls = siteUrlsSelector(getAppStore().getState());
    return siteUrls ? siteUrls.projectUrl(item.id) : '';

  }
  else if (itemType.name === 'flow') {
    const siteUrls = siteUrlsSelector(getAppStore().getState());
    return siteUrls ? siteUrls.flowUrl(item.id) : '';

  }

  throw new Error('State not known for ' + itemType.name);
}
